<template>
    <div class="planned-objective__item" :class="['objective-color__border-color--'+objective.color, {'planned-objective__item--completed': this.objective.activities_count === this.objective.completed_activities_count}]">
        <div class="planned-objective__title">
            <router-link active-class="router-link-active" :to="{name:'my-objective-goal-details',params:{objectiveId:objective.id}}">{{objective.name}}</router-link>
        </div>
        <objective-progress-bar :on-objective="true" :objective="objective"><translate>activities completed</translate></objective-progress-bar>
        <div v-if="nextActivity!==null" class="planned-objective__next-activity">
            <translate>Next activity for this objective:</translate>
            <activity :activity="nextActivity" :show-objective="false"></activity>
        </div>
        <div class="planned-objective__action-buttons">
            <router-link active-class="router-link-active" :to="{name:'my-objective-goal-details',params:{objectiveId:objective.id}}" class="button button--small button--gray">
                <translate>View objective</translate>
            </router-link>
        </div>
    </div>
</template>
<script>
    import ObjectiveProgressBar from "./ObjectiveProgressBar";
    import Activity from "./Activity";

    export default {
        name: 'objective',
        components: {Activity, ObjectiveProgressBar},
        props: {
            objective: {}
        },
        computed: {
            nextActivity: function() {
                for (let i=0; i<this.objective.activities.length; i++) {
                    if (this.objective.activities[i].completed === false) {
                        return this.objective.activities[i]
                    }
                }
                return null
            }
        }
    }
</script>